import {
  AppsListDetail20Regular,
  ChartMultiple20Regular,
  ClipboardTaskListLtr20Regular,
  Diamond20Regular,
  DocumentData20Regular,
  Form20Regular,
  HandLeft20Regular,
  Money20Regular,
  People20Regular,
  Rename20Regular,
  SaveCopy20Regular,
  Temperature20Regular,
} from "@fluentui/react-icons";
import React from "react";

interface ITemplateIconOption {
  key: string;
  label: string;
  icon: JSX.Element;
}

export const templateIconOptions: ITemplateIconOption[] = [
  { key: "Approvals", label: "Approvals", icon: <AppsListDetail20Regular /> },
  {
    key: "ChartMultiple",
    label: "Chart Multiple",
    icon: <ChartMultiple20Regular />,
  },
  {
    key: "ClipBoardTaskList",
    label: "Clip Board Task List",
    icon: <ClipboardTaskListLtr20Regular />,
  },
  { key: "Diamond", label: "Diamond", icon: <Diamond20Regular /> },
  {
    key: "DocumentData",
    label: "Document Data",
    icon: <DocumentData20Regular />,
  },
  { key: "Form", label: "Form", icon: <Form20Regular /> },
  { key: "HandLeft", label: "Hand Left", icon: <HandLeft20Regular /> },
  { key: "Money", label: "Money", icon: <Money20Regular /> },
  { key: "People", label: "People", icon: <People20Regular /> },
  { key: "Rename", label: "Rename", icon: <Rename20Regular /> },
  { key: "Savings", label: "Savings", icon: <SaveCopy20Regular /> },
  { key: "Temperature", label: "Temperature", icon: <Temperature20Regular /> },
];

templateIconOptions.sort((a, b) => a.label.localeCompare(b.label));

const iconMap = new Map(templateIconOptions.map((opt) => [opt.key, opt.icon]));

export const renderTemplateIcon = (iconValue: string): React.ReactNode => {
  const fluentIcon = iconMap.get(iconValue);
  if (fluentIcon) return fluentIcon;
  return iconValue;
};
